import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const TeamSection = ({ teams }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 679 },
      items: 2.5,
    },
    mobile: {
      breakpoint: { max: 678, min: 0 },
      items: 1.5,
    },
  };
  return (
    <>
      <div className="my-20 hidden items-center rounded-md bg-yellow-light p-10 lg:flex">
        <div className="mr-6 lg:w-2/5">
          <h2 className="mb-8 font-satoshi-bold">AlmaBetter Team</h2>
          {/* <div className='text-lg font-satoshi-medium font-semibold leading-8'>
          To be the world’s most student-centric educational institution
          providing incentive aligned education with guaranteed learning
          outcomes.
        </div> */}
        </div>
        <div className="m-0 p-0 pb-4">
          <div className="relative -my-[4.5rem] hidden items-center justify-center md:flex">
            <div className="snap relative flex h-[36rem] w-[46rem] snap-x flex-col items-center overflow-y-scroll lg:snap-y">
              <div className="my-[1rem] mx-0 flex min-h-[36rem] w-full snap-start flex-wrap items-center justify-center gap-6">
                {teams.map((item) => (
                  <TeamCard key={item.id} data={item.attributes} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="my-20 flex flex-col items-center rounded-md bg-yellow-light p-10 md:hidden">
        <div className="mr-6 lg:w-2/5">
          <h2 className="mb-8">AlmaBetter Team</h2>
        </div>
        <div className="mx-auto flex w-screen items-center md:hidden md:w-full lg:mx-0 ">
          <Carousel
            swipeable={true}
            draggable={true}
            responsive={responsive}
            arrows={true}
            ssr={true} // means to render carousel on server-side.
            itemClass="slider-crousel"
            keyBoardControl={true}
            containerClass="carousel-container"
            removeArrowOnDeviceType={['tablet', 'mobile']}
            deviceType="mobile"
            dotListClass="owl-dots"
            showDots={false}
            autoPlay={false}
          >
            {teams.map((item) => (
              <TeamCardMobile key={item.id} data={item.attributes} />
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
};

export default TeamSection;

const TeamCard = ({ data }) => {
  return (
    <div
      style={{ opacity: 1, transform: 'none' }}
      className="relative mx-[0.06rem] flex h-[14rem] w-[12rem] flex-col items-center justify-start rounded-md bg-white shadow-md hover:shadow-lg"
    >
      <div className="-mt-2 flex h-[8.5rem] w-full items-center justify-center rounded-t-md bg-blue-11">
        <img
          className="h-[120px] w-[120px] rounded-full"
          src={data?.image?.data?.attributes?.url}
          alt=""
        />
      </div>
      <div className="absolute right-2 z-[1] mt-[7rem]">
        <div className="uppsercase float-right inline-block rounded bg-white px-2 py-1 font-satoshi-medium text-xs font-medium  leading-tight text-gray-text shadow-md">
          {data.tagLine}
        </div>
      </div>
      <div className="mt-4 flex h-[5.5rem] flex-col items-center justify-center px-2">
        <div className="font-satoshi-bold text-base font-bold  leading-4 text-black">
          {data.name}
        </div>
        <div className="mt-2 text-center font-satoshi-medium text-sm font-semibold leading-3 text-red">
          {data.designation}
        </div>
        <a href={data.linkedinUrl} target="_blank" rel="noreferrer" className="cursor-pointer">
          <img
            src="/assets/icons/courses-icons/LinkedIn@2x.png"
            alt=""
            className="mt-2 h-[23px] w-[23px]"
          />
        </a>
        {/* <p className='text-gray-text-2 font-thin text-sm my-4'>
              IIT Kharagur, Ex Blackbuck, Reliance, Radware
            </p> */}
      </div>
    </div>
  );
};

const TeamCardMobile = ({ data }) => {
  return (
    <div
      style={{ opacity: 1, transform: 'none' }}
      className="relative my-4 flex h-[16rem] w-[12rem] flex-col items-center justify-start rounded-md bg-white shadow-md hover:shadow-lg"
    >
      <div className="-mt-4 flex h-[8.5rem] w-full items-center justify-center rounded-t-md bg-blue-11">
        <img
          className="h-[120px] w-[120px] rounded-full"
          src={data?.image?.data?.attributes?.url}
          alt=""
        />
      </div>
      <div className="absolute right-2 z-[1] mt-[7rem]">
        <div className="uppsercase float-right inline-block rounded bg-white px-2 py-1 font-satoshi-medium text-sm font-medium  leading-tight text-gray-text shadow-md">
          {data.tagLine}
        </div>
      </div>
      <div className="mt-10 flex h-[5.5rem] flex-col items-center justify-center px-2">
        <div className="font-satoshi-bold text-base font-bold  leading-4 text-black">
          {data.name}
        </div>
        <div
          className="leading-2 mt-2 text-center font-satoshi-medium text-base font-semibold text-red"
          style={{ lineHeight: '14px' }}
        >
          {data.designation}
        </div>
        <a href={data.linkedinUrl} target="_blank" rel="noreferrer" className="cursor-pointer">
          <img
            src="/assets/icons/courses-icons/LinkedIn@2x.png"
            alt=""
            className="mt-2 h-[23px] w-[23px]"
          />
        </a>
        {/* <p className='text-gray-text-2 font-thin text-sm my-4'>
              IIT Kharagur, Ex Blackbuck, Reliance, Radware
            </p> */}
      </div>
    </div>
  );
};
